export default "__VITE_ASSET__tLi5usmN__"